import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=8d19bff8"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"
import style0 from "./Related.vue?vue&type=style&index=0&id=8d19bff8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports